import React from 'react';

import { Box, Skeleton, Typography } from '@mui/material';
import RoundedBox from '@sharedCR/common/RoundedBox';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { getValueOrDash } from 'utils/data';

import { fieldColumnStyles, sectionGridStyles } from './ShipperMilestoneSection.styles';

const ShipperMilestoneSection = ({ isLoading, config }) => (
  <RoundedBox padding={16}>
    <Box sx={sectionGridStyles}>
      {config.map(({ id, name, value }) => (
        <Box key={id} sx={fieldColumnStyles}>
          {isLoading ? (
            <Skeleton height={50} variant="text" />
          ) : (
            <>
              <Typography color="text.secondary" variant="regular14">
                {name}
              </Typography>
              <Typography variant="bold16">{getValueOrDash(value)}</Typography>
            </>
          )}
        </Box>
      ))}
    </Box>
  </RoundedBox>
);

ShipperMilestoneSection.propTypes = {
  ...WithLoadingPropTypes,
  config: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      value: PropTypes.string,
    }),
  ).isRequired,
};

export default ShipperMilestoneSection;
